import React, { useEffect, useState } from "react";
import { formatInTimeZone } from "date-fns-tz";
import LoadEditorFormExtraload from "./LoadEditorFormExtraload";
import LoadEditorTravelTable from "./LoadEditorTravelTable";
import Header from "../../../components/header";
import { getLocationsByGroups } from "../../../services/locationsApi";
import { transformSelectFormat } from "../../../utils/transformFormatSelect";
import { getEquipmentsByType } from "../../../services/equipmentsAPI";
import {
  getMaterial,
  getMaterialBlocks,
  getMaterialClass,
  getPitLevel,
  getShiftAndHours,
  getTravelTypes,
} from "../services/getData";
import { format } from "date-fns";
import { getSettingsModulesByID } from "../../../services/settingsModules";

const LoadEditor = ({ ApplicationId, UserId, ModuleId }) => {
  /*
    -AL ABRIR EL MODULO ES NECESARIO OBTENER LOS SIGUIENTES PARAMETROS DESDE BACKEND
      - Id de camion
      - Id de excavadora
      - Id de Origen
      - Id de Destino
  */

  const [paramLocationOriginGroups, setParamLocationOriginGroups] = useState([284]);
  const [paramLocationDestinationGroups, setParamLocationDestinationGroups] = useState([285]);
  const [paramTrucks, setParamTrucks] = useState([78]);
  const [paramShovel, setParamShovel] = useState([80]);

  const [allOriginList, setAllOriginList] = useState([]);
  const [allDestinationList, setAllDestinationList] = useState([]);
  const [allTruckList, setAllTruckList] = useState([]);
  const [allShovelList, setAllShovelList] = useState([]);
  const [allHourList, setAllHourList] = useState([]);
  const [allTravelType, setAllTravelType] = useState([]);

  const [allMaterial, setAllMaterial] = useState([]);
  const [allMaterialBlock, setAllMaterialBlock] = useState([]);
  const [allMaterialClass, setAllMaterialClass] = useState([]);
  const [allPitLevel, setAllPitLevel] = useState([]);
  const [allShiftList, setAllShiftList] = useState([
    { value: "0", label: "Select Shift" },
    { value: "Day", label: "Day" },
    { value: "Night", label: "Night" },
  ]);
  const [allRehandle, setAllRehandle] = useState([
    { value: "0", label: "Select Rehandle" },
    { value: true, label: "True" },
    { value: false, label: "False" },
  ]);

  const [configInputs, setConfigInputs] = useState({
    material_block: { is_show: false },
    material_class: { is_show: true },
    pit_level: { is_show: true },
    density: { is_show: true, min_value: 0, max_value: 100 },
    rehandle: { is_show: true },
    grade1: { is_show: true, min_value: 0, max_value: 100 },
    grade2: { is_show: true, min_value: 0, max_value: 100 },
    shift_date: { is_show: true, min_value: null, max_value: null },
  });

  const [selectedShift, setSelectedShift] = useState([]);
  const [actualShift, setActualShift] = useState(null);

  useEffect(() => {
    (async () => {
      initializeHourAndShift();
      initializeLocations();
      initializeEquipments();
      initializeTravelTypes();
      initializeMaterial();
      initializeMaterialBlock();
      initializeMaterialClass();
      initializePitLevel();
      initializeSettingsInputs();
      //console.log("Open Component");
      //console.log("USER ID: ", UserId);
      //console.log("Module ID: ", ModuleId);
      //console.log("App ID: ", ApplicationId);
    })();
  }, []);

  const initializeLocations = async () => {
    const result_location_origin = await getLocationsByGroups(
      paramLocationOriginGroups, ApplicationId
    );
    if (result_location_origin) {
      const select_result_location_origin = transformSelectFormat(
        result_location_origin.info_location,
        "location_id",
        "name"
      );
      //console.log(select_result_location_origin);
      if (select_result_location_origin.status == 200) {
        setAllOriginList(select_result_location_origin.data);
      }
    }
    const result_location_destination = await getLocationsByGroups(
      paramLocationDestinationGroups, ApplicationId
    );
    //console.log(result_location_destination);

    if (result_location_destination) {
      const select_result_location_destination = transformSelectFormat(
        result_location_destination.info_location,
        "location_id",
        "name"
      );
      if (select_result_location_destination.status == 200) {
        setAllDestinationList(select_result_location_destination.data);
      }
    }
  };
  const initializeEquipments = async () => {
    const result_trucks = await getEquipmentsByType(paramTrucks, ApplicationId);
    //console.log(result_trucks);
    if (result_trucks) {
      const select_result_trucks = transformSelectFormat(
        result_trucks.info_equipments,
        "equipment_id",
        "equipment_name"
      );
      //console.log(select_result_trucks);
      if (select_result_trucks.status == 200) {
        setAllTruckList(select_result_trucks.data);
      }
    }
    const result_shovel = await getEquipmentsByType(paramShovel, ApplicationId);
    //console.log(result_shovel);

    if (result_shovel) {
      const select_result_shovels = transformSelectFormat(
        result_shovel.info_equipments,
        "equipment_id",
        "equipment_name"
      );
      if (select_result_shovels.status == 200) {
        setAllShovelList(select_result_shovels.data);
      }
    }
  };
  const initializeHourAndShift = async () => {
    const result_shift_hours = await getShiftAndHours(null, null, ApplicationId);
    if (result_shift_hours) {
      //console.log(result_shift_hours);
      const select_shift_hour = transformSelectFormat(
        result_shift_hours.shift_info,
        "hsl_column",
        "hsl_hour"
      );
      if (select_shift_hour.status == 200) {
        //console.log(select_shift_hour);
        setAllHourList(select_shift_hour.data);
        //console.log(result_shift_hours.shift);
        setSelectedShift({
          value: result_shift_hours.shift,
          label: result_shift_hours.shift,
        });
        //console.log(result_shift_hours.actual_shift);
        //console.log(result_shift_hours.actual_shift.actual_shift);
        let formatted = await formatInTimeZone(
          new Date(result_shift_hours.actual_shift.actual_shift),
          "UTC",
          "yyyy-MM-dd"
        );
        //console.log("+++++++++++++++++");
        //console.log(formatted);
        //console.log("+++++++++++++++++");
        setActualShift(formatted);
      }
    }
  };
  const initializeTravelTypes = async () => {
    const result_travel_types = await getTravelTypes(ApplicationId);
    if (result_travel_types) {
      //console.log(result_shift_hours);
      const select_travel_types = transformSelectFormat(
        result_travel_types.info_travel_types,
        "travel_type_id",
        "travel_type_name"
      );
      if (select_travel_types.status == 200) {
        //console.log(select_shift_hour);
        setAllTravelType(select_travel_types.data);
      }
    }
  };
  const initializeMaterial = async () => {
    const result_material = await getMaterial(ApplicationId);
    if (result_material) {
      //console.log(result_shift_hours);
      const select_material = transformSelectFormat(
        result_material.info_materials,
        "material_id",
        "material_name"
      );
      if (select_material.status == 200) {
        //console.log(select_shift_hour);
        setAllMaterial(select_material.data);
      }
    }
  };
  const initializeMaterialBlock = async () => {
    const result_material_block = await getMaterialBlocks(ApplicationId);
    if (result_material_block) {
      //console.log(result_shift_hours);
      const select_material_block = transformSelectFormat(
        result_material_block.info_materials_block,
        "block_names_record_id",
        "block_names_record_name"
      );
      if (select_material_block.status == 200) {
        //console.log(select_shift_hour);
        setAllMaterialBlock(select_material_block.data);
      }
    }
  };
  const initializeMaterialClass = async () => {
    const result_material_class = await getMaterialClass(ApplicationId);
    if (result_material_class) {
      //console.log(result_shift_hours);
      const select_material_class = transformSelectFormat(
        result_material_class.info_material_class,
        "material_class_id",
        "material_class_name"
      );
      if (select_material_class.status == 200) {
        //console.log(select_shift_hour);
        setAllMaterialClass(select_material_class.data);
      }
    }
  };
  const initializePitLevel = async () => {
    const result_pit_level = await getPitLevel(ApplicationId);
    if (result_pit_level) {
      //console.log(result_shift_hours);
      const select_pit_level = transformSelectFormat(
        result_pit_level.info_pit_level,
        "pit_level_material_id",
        "pit_level_material"
      );
      if (select_pit_level.status == 200) {
        //console.log(select_shift_hour);
        setAllPitLevel(select_pit_level.data);
      }
    }
  };
  const initializeSettingsInputs = async () => {
    if (ApplicationId && UserId && ModuleId) {
      //console.log("Se va a solicitar la configuracion del modulo");
      //console.log(ApplicationId);
      //console.log(UserId);
      //console.log(ModuleId);
      const result_settings = await getSettingsModulesByID(
        ApplicationId,
        UserId,
        ModuleId
      );
      //console.log("777777777777777777777777777777777");
      //console.log(result_settings);
      //console.log("777777777777777777777777777777777");
      if (result_settings.status == 200) {
        //console.log("--------------------------------------------------");
        //console.log(configInputs);
        //console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
        //console.log(result_settings.params.result_module_inputs);
        //console.log("--------------------------------------------------");
        setConfigInputs(result_settings.params.result_module_inputs);
      }
    }
  };

  return (
    <div className="App">
      <div className="m-px">
        <Header title="Load Editors" />
        <LoadEditorFormExtraload
          is_automatic={true}
          title={"Add Extraload Per Hour"}
          is_open={true}
          allOriginList={allOriginList}
          allDestinationList={allDestinationList}
          allTruckList={allTruckList}
          allShovelList={allShovelList}
          AllHourListAux={allHourList}
          selectedShiftAux={selectedShift}
          allShift={allShiftList}
          allMaterial={allMaterial}
          allMaterialBlock={allMaterialBlock}
          allMaterialClass={allMaterialClass}
          allPitLevel={allPitLevel}
          allRehandle={allRehandle}
          configInputs={configInputs}
          actualShift={actualShift}
        />

        <LoadEditorFormExtraload
          is_automatic={false}
          title={"Add Extraload Per Shift"}
          is_open={false}
          allOriginList={allOriginList}
          allDestinationList={allDestinationList}
          allTruckList={allTruckList}
          allShovelList={allShovelList}
          AllHourListAux={allHourList}
          selectedShiftAux={selectedShift}
          allShift={allShiftList}
          allMaterial={allMaterial}
          allMaterialBlock={allMaterialBlock}
          allMaterialClass={allMaterialClass}
          allPitLevel={allPitLevel}
          allRehandle={allRehandle}
          configInputs={configInputs}
          actualShift={actualShift}
        />
        {actualShift && (
          <LoadEditorTravelTable
            allTruckList={allTruckList}
            allShovelList={allShovelList}
            allOriginList={allOriginList}
            allDestinationList={allDestinationList}
            allShift={allShiftList}
            permissionUpdate={true}
            permissionDelete={true}
            allTravelTypes={allTravelType}
            actualShift={actualShift}
            allMaterialList={allMaterial}
            configInputs={configInputs}
            allMaterialBlock={allMaterialBlock}
            allMaterialClass={allMaterialClass}
            allPitLevel={allPitLevel}
            allRehandle={allRehandle}
          />
        )}
      </div>
    </div>
  );
};

export default LoadEditor;
